import { render } from "./profileThree.vue?vue&type=template&id=2725faf2"
import script from "./profileThree.vue?vue&type=script&lang=js"
export * from "./profileThree.vue?vue&type=script&lang=js"

import "./profileThree.vue?vue&type=style&index=0&id=2725faf2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__